import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  PersonalInformationDialog,
  PersonalInformationDialogCallbackInput,
  PersonalInformationUniqueProps,
} from '../PersonalInformationDialog';

const { useDialogForContext, useDialog: usePersonalInformationDialog } =
  getDialogHooks<
    PersonalInformationUniqueProps,
    PersonalInformationDialogCallbackInput
  >(PersonalInformationDialog);
export const usePersonalInformationDialogForContext = useDialogForContext;
export default usePersonalInformationDialog;
